import { ChevronDownIcon } from "lucide-react";

import { cn } from "../../lib/cn.js";

/**
 * A NATIVE `<select>`, styled to match shadcn's trigger.
 *
 * Legacy uses Radix's Select here. This does not, and the reason is worth stating: a
 * native select is one element, needs no portal, no popper and no focus management, and
 * on a phone it opens the platform's own picker — which is better than a rebuilt listbox
 * for a control whose entire job is "50 / 100 / 250 rows". It carries the same border,
 * height, radius and focus ring, so it reads as the same control.
 *
 * If a later screen needs multi-select, groups or rich option content, that screen should
 * bring in Radix's Select rather than bend this one.
 */
export function Select({ className, children, ...props }: React.ComponentProps<"select">): React.JSX.Element {
  return (
    <div className="relative">
      <select
        className={cn(
          "border-input flex h-9 w-full appearance-none rounded-md border bg-transparent py-1 pr-8 pl-3 text-sm shadow-xs transition-[color,box-shadow] outline-none",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDownIcon className="text-muted-foreground pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2" />
    </div>
  );
}
